"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConfigProvider = void 0;

var _configProvider = _interopRequireDefault(require("antd/lib/config-provider"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _themeUi = require("theme-ui");

var _ConfigContext = require("./ConfigContext");

var _themes = _interopRequireDefault(require("../../themes"));

var _excluded = ["children", "theme", "prefixCls"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RAINBOW_THEME = process.env.RAINBOW_THEME;
/**
 * Config context provider stores shared state
 *
 * *If no theme supplied: falls back to theme name on process.env.RAINBOW_THEME, otherwise uses defaultTheme*
 */

var ConfigProvider = function ConfigProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _themes["default"][RAINBOW_THEME] || _themes["default"].defaultTheme : _ref$theme,
      _ref$prefixCls = _ref.prefixCls,
      prefixCls = _ref$prefixCls === void 0 ? 'ant' : _ref$prefixCls,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_ConfigContext.ConfigContext.Provider, {
    value: _objectSpread({
      theme: theme
    }, props)
  }, /*#__PURE__*/_react["default"].createElement(_configProvider["default"], {
    prefixCls: prefixCls
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: _objectSpread(_objectSpread({}, theme), {}, {
      prefixCls: prefixCls
    })
  }, /*#__PURE__*/_react["default"].createElement(_themeUi.ThemeProvider, {
    theme: theme
  }, children))));
};

exports.ConfigProvider = ConfigProvider;
ConfigProvider.propTypes = {
  theme: _propTypes["default"].object
};
var _default = ConfigProvider;
exports["default"] = _default;